export default "__VITE_ASSET__BsUpnQxB__"